<template>
  <div class="home">
    <div class>
      <div class="washi-topbar content" style="width: auto">
        <div class="logo" />

        <div class="right-buttons">
          <router-link :to="{ name: 'login' }">
            <div class="main-button small reverse" style="width: auto; height: auto; padding: 6px 12px">
              {{ $t('home.topbar.login') }}
            </div>
          </router-link>

          <router-link :to="{ name: 'register' }">
            <div class="main-button small" style="width: auto; height: auto; padding: 6px 12px">
              {{ $t('home.topbar.signUp') }}
            </div>
          </router-link>
        </div>
      </div>

      <div id="about" class="about content">
        <div class="left">
          <div class="washi-title">{{ $t('home.about.title') }}</div>
          <div class="text" v-html="$t('home.about.text_html')"></div>
          <router-link :to="{ name: 'register' }">
            <button class="main-button create">
              {{ $t('home.about.startButton') }}
            </button>
          </router-link>
        </div>
        <div class="right" />
      </div>
      <div class="mission content">
        <div class="img" />
        <div class="info">
          <div class="washi-title">{{ $t('home.mission.title') }}</div>
          <div class="text" v-html="$t('home.mission.text_html')"></div>
        </div>
      </div>

      <div class="page-footer content">
        <router-link :to="{ name: 'register' }">
          <div class="button">{{ $t('home.footer.signUp') }}</div>
        </router-link>

        <div class="divider" />

        <router-link :to="{ name: 'login' }">
          <div class="button">{{ $t('home.footer.login') }}</div>
        </router-link>

        <div class="divider" />

        <a href="mailto:hello@washi.io">
          <div class="button">{{ $t('home.footer.contact') }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomeView',

  computed: {
    ...mapGetters(['templates']),
  },
  async created() {
    if (this.$auth.isLogged()) {
      this.$router.push({ name: 'dashboard' });
      return;
    }
    this.$store.dispatch('templates.fetch');
  },
  methods: {
    async createResume() {
      const lastResumeId = localStorage.getItem('editingResume');
      if (lastResumeId) {
        const result = await this.$store.dispatch('setPopup', {
          popupType: 'ConfirmPopup',
          popupData: {
            title: this.$t('home.popup.createResume.title'),
            content: this.$t('home.popup.createResume.message'),
            confirm: this.$t('home.popup.createResume.createNew'),
            cancel: this.$t('home.popup.createResume.resumeEditing'),
            config: { extendButton: true },
          },
        });
        if (result === false) {
          this.$router.push({ name: 'editor', params: { id: lastResumeId } });
          return;
        } else if (result === undefined) {
          return;
        }
      }
      const candidate = {
        firstname: 'Nom complet',
        lastname: '',
        jobTitle: '',
        referenceLink: '',
      };
      const template = this.templates[0];
      try {
        const resume = await this.$store.dispatch('resumes.create', {
          candidate,
          template,
        });

        localStorage.setItem('editingResume', resume.id);

        this.$router.push({ name: 'editor', params: { id: resume.id } });
      } catch (e) {
        console.error(e);
        if (e.response.status === 429) {
          alert('quota exceded');
        } else {
          alert(e.response.data);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.text b {
  font-weight: 500 !important;
}
</style>
<style scoped lang="scss">
@use '@/styles/colors.scss';

$margin: 64px;
$layout-breakpoint-small: 512px;

.home {
  background: white;
  overflow-x: hidden;

  .washi-title {
    margin-bottom: $margin;
    line-height: 44px;
    font-size: 36px;
    font-weight: bold;
  }
  .text {
    font-size: 20px;
    line-height: 30px;
    width: 608px;
    color: #000000;
    font-family: 'Lato', sans-serif;
    font-weight: 300;
  }
  & > div {
    height: 100%;
  }

  .washi-topbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 32px;
    max-width: stretch;

    .logo {
      width: 192px;
      background-image: url('../assets/Logo_Washi.svg?file-css');
      aspect-ratio: 512/128;
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
    }

    .right-buttons {
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }
  .about {
    margin-top: $margin;
    display: flex;
    position: relative;
    align-items: unset;
    &::after {
      position: absolute;
      bottom: 0;
      left: calc(-50vw);
      width: 200vw;
      content: '';
      background: colors.$lighter-yellow-color;
      height: 256px;
      z-index: 1;

      @media screen and (max-width: 1184px) {
        content: unset;
      }
    }
    .left {
      max-width: calc(50% - 84px);
      margin-bottom: 256px + 32px;
      margin-left: 84px;

      @media screen and (max-width: 1632px) {
        max-width: 52%;
        margin-left: 70px;
      }

      @media screen and (max-width: 1408px) {
        max-width: 60%;
        margin-left: 54px;
      }

      @media screen and (max-width: 1184px) {
        max-width: 65%;
        margin-left: 30px;
      }

      @media screen and (max-width: 960px) {
        max-width: 100%;
      }
    }
    .right {
      background-image: url('../assets/home/main-illu.png');
      background-position: bottom right;
      background-repeat: no-repeat;
      background-size: contain;
      flex-grow: 1;
      z-index: 2;
    }
    .main-button {
      margin-top: 32px;
    }
  }
  .mission {
    font-size: 39px;
    line-height: 48px;
    display: flex;
    justify-content: space-between;
    padding: $margin 0;
    align-items: unset;
    .washi-title {
      font-weight: bold;
    }
    .img {
      width: 45%;
      background-image: url('../assets/home/time-illu.svg?file-css');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    .info {
      width: 45%;
      margin-right: 5%;
      font-size: 20px;
      line-height: 29px;
    }
  }

  .page-footer {
    display: flex;
    align-items: center;
    margin-top: 64px;
    padding-bottom: 64px;
    justify-content: flex-start;
    gap: 32px;

    .button {
      font-size: 16px;
      cursor: pointer;
      transition: 0.3s;
      margin: 8px;

      &:hover {
        color: colors.$secondary-color;
      }
    }

    .divider {
      display: none;
    }
  }
}

@media screen and (max-width: 1184px) {
  .home {
    .washi-topbar {
      padding: 16px;
      flex-grow: 1;
      box-sizing: border-box;
      justify-content: space-between;
      max-width: 100vw;

      .logo {
        width: 72px;
      }

      .right-buttons .main-button {
        width: 80px;
        height: 22px;
        font-weight: 900;
        font-size: 11px;
        padding: 0;
      }
    }
  }

  .about {
    width: calc(100% - 70px);
    flex-grow: 1;
    padding: 0 40px;
    flex-direction: column;
    position: relative;
    margin-top: 16px !important;

    .left {
      margin: 0 !important;

      .washi-title {
        font-size: 21px;
        line-height: 26px;
        margin-bottom: 16px !important;
      }

      .text {
        width: fit-content;
        font-size: 16px;
        line-height: 24px;
      }

      .main-button {
        margin-bottom: 92px;
        height: 35px;
        width: 136px;
        font-weight: 900;
        font-size: 12px;
        padding: 0;
      }
    }

    .right {
      position: absolute;
      left: -44px;
      z-index: 0;
      right: -44px;
      bottom: 0;
      height: 45px;
      background: colors.$lighter-yellow-color;
      background-image: unset !important;

      &::after {
        position: absolute;
        content: '';
        bottom: 0;
        right: 52px;
        width: 125px;
        height: 142px;
        background-image: url('../assets/home/main-illu.png');
        background-position: bottom right;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }

  .mission {
    width: calc(100% - 70px);
    flex-grow: 1;
    flex-direction: column-reverse;
    padding: 32px 0 !important;

    .info {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      width: 100% !important;
      margin: 0 !important;

      .washi-title {
        font-size: 21px;
        line-height: 26px;
        margin: 0 0 18px 0;
      }

      .text {
        width: fit-content;
        font-size: 16px;
        line-height: 24px;
      }
    }

    .img {
      width: 100% !important;
      height: 200px;
    }
  }

  .page-footer {
    display: flex;
    align-items: center;
    justify-content: center !important;
    gap: 16px !important;
    flex-direction: column;
    padding-bottom: 16px !important;
    margin-top: 0 !important;

    .button {
      margin: 0 !important;
      font-size: 9px;
    }

    .divider {
      display: block !important;
      height: 1px;
      width: 18px;
      background-color: colors.$main-color;
      margin: 0 12px;
    }
  }
}

@media screen and (max-width: $layout-breakpoint-small) {
  .main-button.create {
    display: none;
  }
  .left {
    min-height: 430px;
  }
}
</style>
